module.exports = "https://assets.pclncdn.com/web/next-landing/b8f04f44e5/_next/static/images/cobrand-cruises-only-promo-22829eb309ed1658cbaafb48728200cc.jpg";